export default __webpack_public_path__ + "static/media/AcceptOrderOn.f0306063.svg";